import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import DateConverter from "@heartinz/date_and_time_processor";
import { capitalizeFirstLetter } from "../../../utils/helper";
import uRLs from "../../../utils/baseUtils";
import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import axiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constant/handleError";
import useShowAlert from "../../../utils/AlertUtiles";

function PaymentHistory({
  setPayment,
  isPayment,
  handleClose,
  isSelectedData,
  handleOpen,
  // loading,
}) {
  // const [isPayment, setPayment] = useState([]);
  const [isLoadingBtn, setBtnLoading] = useState({
    initialteRefund:"",
    listPayment:false,
    verifyRefund:"",
    refundExcess:""
  });

  const [refundModal, setRefundModal] = useState({
    open: false,
    paymentHistoryId: "",
    bookingId: "",
    amount: "",
  });
  const [verifyRefundModal, setVerifyRefundModal] = useState({
    open: false,
    paymentHistoryId: "",
    bookingId: "",
    refundId: "",
    amount: "",
  });
  const [refundAmount, setRefundAmount] = useState("");
  const [manualRefundModal, setManualRefundModal] = useState({
    open: false,
    statusHistoryId: "",
    bookingId: "",
    amount: "",
  });
  const [manualRefundRemarks, setManualRefundRemarks] = useState("");
  const [cashLedger, setCashLedger] = useState([]);
  const isPaymentComplete =
    isSelectedData?.totalPaid === isSelectedData?.totalAmount;
  const showAlert = useShowAlert();

  const getStatusStyles = (status) => {
    const s = (status || "").toUpperCase();

    if (s === "PAID" || s === "REFUNDED") {
      return {
        borderLeft: "4px solid #4caf50",
        background: "#f1fff6",
        textColor: "#4caf50",
      };
    }

    if (s === "STARTED" || s === "PENDING") {
      return {
        borderLeft: "4px solid #ff9800",
        background: "#fff8e1",
        textColor: "#ff9800",
      };
    }
    if (s === "FAILED") {
      return {
        borderLeft: "4px solid #ff0000ff",
        background: "#fff8e1",
        textColor: "#ff0008ff",
      };
    }

    return {
      borderLeft: "4px solid #9e9e9e",
      background: "#f5f5f5",
      textColor: "#757575",
    };
  };

  let paymentStatusText;
  let statusColor;

  if (isPaymentComplete) {
    paymentStatusText = "Payment Completed";
    statusColor = "green";
  } else if (isSelectedData?.totalPaid > 0) {
    paymentStatusText = "Partial Payment Received";
    statusColor = "#ffa726";
  } else {
    paymentStatusText = "Payment Pending";
    statusColor = "gray";
  }
  const [payLoading, setPayLoading] = useState(false);
  const handlePaymentCheckResponse = (response, setPayment) => {
    if (response?.data?.status && response?.data?.results) {
      const newStatusHistory = response.data.results.statusHistoryData;
      setPayment((prevHistory) => {
        const currentHistory = Array.isArray(prevHistory) ? prevHistory : [];

        const updatedItemId = newStatusHistory._id;
        const itemIndex = currentHistory.findIndex(
          (item) => item._id === updatedItemId,
        );

        let newHistory;

        if (itemIndex > -1) {
          newHistory = [...currentHistory];
          newHistory[itemIndex] = newStatusHistory;
        } else {
          newHistory = [...currentHistory, newStatusHistory];
        }

        return newHistory;
      });
    }
  };
  const handlePaymentCheck = async (paymentHistoryId, bookingId) => {
    checkNetworkStatus();
    setPayLoading(true);
    try {
      const data = {
        paymentHistoryId: paymentHistoryId,
        bookingId: bookingId,
      };
      const response = await axiosInstance.patch(
        `farmerbooking/admin/check-payment`,
        data,
      );
      if (response && response?.data?.status && response?.data?.results) {
        const newStatusHistory = response?.data?.results?.statusHistoryData;
        setPayment((prevHistory) => {
          const history = Array.isArray(prevHistory) ? prevHistory : [];
          const index = history.findIndex(
            (item) => item._id === newStatusHistory._id,
          );

          if (index !== -1) {
            const updated = [...history];
            updated[index] = newStatusHistory;
            return updated;
          }
          return [...history, newStatusHistory];
        });
        handlePaymentCheckResponse(
          {
            data: {
              status: true,
              results: {
                statusHistoryData: newStatusHistory,
              },
            },
          },
          setPayment,
        );
      }
      showAlert("success", response?.data?.message);
    } catch (error) {
      if (error.response?.data?.statusCode === 400) {
        showAlert("warning", "Payment not completed");
      } else {
        handleError(error, showAlert);
      }
    } finally {
      setPayLoading(false);
    }
  };
  const fetchPaymentDetails = async () => {
    checkNetworkStatus();
    setBtnLoading((prev) => ({ ...prev, listPayment: true }));
    try {
      const response = await axiosInstance.get(
        `farmerbooking/admin/payment-status/${isSelectedData?._id}`,
      );
      if (response && response?.data?.status && response?.data?.results) {
         const filteredData = [];

      response.data.results.forEach((item) => {
        const exists = filteredData.some(
          (p) => p.paymentHistoryId === item.paymentHistoryId
        );

        if (!exists) {
          filteredData.push(item);
        }
      });

      setPayment(filteredData);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
     setBtnLoading((prev) => ({ ...prev, listPayment: false }));
          }
  };
  useEffect(() => {
    fetchPaymentDetails();
  }, []);
  const getPaymentMethodClass = (method) => {
    switch ((method || "").toUpperCase()) {
      case "CASH":
        return "text-blue";
      case "UPI":
        return "text-moon";
      case "CARD":
        return "text-flower";
      default:
        return "text-muted";
    }
  };
  const handleInitiateRefund = async (paymentHistoryId, bookingId, amount) => {
    try {
       setBtnLoading((prev) => ({
    ...prev,
    initialteRefund: paymentHistoryId,
  }));
      const data = {
        amount: amount,
      };
      const resData = await axiosInstance.patch(
        `farmerbooking/admin/${bookingId}/initiate-refund/${paymentHistoryId}`,
        data,
      );

      showAlert("success", resData?.data?.message);
     setPayment((prevHistory) => {
  const currentHistory = Array.isArray(prevHistory) ? prevHistory : [];

  const apiResults = resData?.data?.results;

  const newRefundHistoryItem = {
    _id: apiResults?.refundId || new Date().getTime().toString(),
    bookingId: apiResults?.bookingId,
    bookingNumber: apiResults?.bookingNumber,
    farmerId: apiResults?.farmerId,
    paymentHistoryId: apiResults?.paymentHistoryId,
    refundId: apiResults?.refundId,
    bookingTracking: apiResults?.bookingStatus,
    trackType: "PAYMENTTRACK",
    amount: apiResults?.refundAmount,
    time: new Date().toISOString(),
    entryBy: "OWNER",
    refundCompleted: false,
    refundStatus: apiResults?.refundStatus,
    refundMode: "PAYMENTGATEWAY",
  };

  const filteredHistory = currentHistory.filter(
    (item) =>
      item.paymentHistoryId !== apiResults?.paymentHistoryId
  );

  return [newRefundHistoryItem, ...filteredHistory];
});
      // fetchPaymentDetails();
    } catch (error) {
      handleError(error, showAlert);
    } finally {
        setBtnLoading((prev) => ({
      ...prev,
      initialteRefund: "",
    }));
    }
  };
  // Excess is set by the backend's payment-reconciliation logic when a
  // confirmed Cashfree payment would have pushed totalPaid past
  // totalAmount (e.g. two separate attempts both actually succeeded before
  // either got reconciled) — the money was genuinely charged, so this
  // refunds exactly that leftover back to the farmer via Cashfree.
  const handleRefundExcess = async (paymentHistoryId) => {
    checkNetworkStatus();
    setBtnLoading((prev) => ({ ...prev, refundExcess: paymentHistoryId }));
    try {
      const response = await axiosInstance.patch(
        `farmerbooking/admin/refund-excess/${paymentHistoryId}`,
      );
      showAlert("success", response?.data?.message);
      setPayment((prevHistory) => {
        const currentHistory = Array.isArray(prevHistory) ? prevHistory : [];
        return currentHistory.map((item) =>
          item.paymentHistoryId === paymentHistoryId
            ? { ...item, excessRefundedAt: new Date().toISOString() }
            : item,
        );
      });
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setBtnLoading((prev) => ({ ...prev, refundExcess: "" }));
    }
  };

  const fetchCashLedger = async (bookingId) => {
    if (!bookingId) return;
    try {
      const response = await axiosInstance.get(`farmerbooking/admin/cash-ledger/${bookingId}`);
      if (response?.data?.status) {
        setCashLedger(response.data.results || []);
      }
    } catch (error) {
      // Non-critical read — no ledger entries yet is a normal state, don't alert.
    }
  };

  useEffect(() => {
    fetchCashLedger(isSelectedData?._id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelectedData?._id]);

  const handleInitiateManualRefund = async (statusHistoryId, bookingId, amount, remarks) => {
    try {
      setBtnLoading((prev) => ({ ...prev, initialteRefund: statusHistoryId }));
      const resData = await axiosInstance.patch(
        `farmerbooking/admin/${bookingId}/manual-refund/${statusHistoryId}`,
        { amount, remarks }
      );
      showAlert("success", resData?.data?.message);
      setPayment((prevHistory) => {
        const currentHistory = Array.isArray(prevHistory) ? prevHistory : [];
        const newRefundHistoryItem = resData?.data?.results?.refundStatusHistoryData;
        return newRefundHistoryItem ? [newRefundHistoryItem, ...currentHistory] : currentHistory;
      });
      fetchCashLedger(bookingId);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setBtnLoading((prev) => ({ ...prev, initialteRefund: "" }));
    }
  };

  const handleVerifyRefund = async (paymentHistoryId, bookingId, refundId) => {

    
    checkNetworkStatus();
  setBtnLoading((prev) => ({
    ...prev,
    verifyRefund: refundId,
  }));
    try {
      const data = {
        paymentHistoryId,
        refundId,
      };

      const response = await axiosInstance.patch(
        `farmerbooking/admin/confirm-refund/${bookingId}`,
        data,
      );

      if (
        response?.data?.status &&
        response?.data?.results?.statusHistoryData
      ) {
        const updatedRefund = response.data.results.statusHistoryData;
        setPayment((prev) => {
                const history = Array.isArray(prev) ? prev : [];

                // Check by _id, or fall back to refundId / paymentHistoryId to ensure a definitive match
                const index = history.findIndex(
                  (item) => 
                    item._id === updatedRefund._id || 
                    (item.refundId && item.refundId === updatedRefund.refundId) ||
                    (item.paymentHistoryId && item.paymentHistoryId === updatedRefund.paymentHistoryId)
                );

                if (index !== -1) {
                  const updated = [...history];
                  // Merge old properties with new ones to avoid losing structural data needed by your UI layout
                  updated[index] = { ...updated[index], ...updatedRefund };
                  return updated;
                }

                return [...history, updatedRefund];
        });
    
        // setPayment((prev) => {
        //   const history = Array.isArray(prev) ? prev : [];

        //   const index = history.findIndex(
        //     (item) => item._id === updatedRefund._id,
        //   );

        //   if (index !== -1) {
        //     const updated = [...history];
        //     updated[index] = updatedRefund;
        //     return updated;
        //   }

        //   return [...history, updatedRefund];
        // });
      }

      showAlert("success", response?.data?.message);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
         setBtnLoading((prev) => ({
      ...prev,
      verifyRefund: "",
    }));
    }
  };
  const getTransactionTitle = (item) => {
  if (item.bookingTracking === "REFUND") {
    return "Refund Request";
  }

  return "Payment Received";
};

const getTransactionStatus = (item) => {
  if (item.bookingTracking === "REFUND") {
    switch (item.refundStatus) {
      case "PENDING":
      case "STARTED":
        return "Refund Processing";

      case "REFUNDED":
      case "COMPLETED":
        return "Refund Completed";

      case "FAILED":
        return "Refund Failed";

      default:
        return item.refundStatus;
    }
  }

  switch (item.paymentStatus) {
    case "PAID":
      return "Payment Completed";

    case "STARTED":
      return "Payment Processing";

    case "FAILED":
      return "Payment Failed";

    default:
      return item.paymentStatus;
  }
};

const getActionByText = (item) => {
  if (item.bookingTracking === "REFUND") {
    return "Refund Initiated By";
  }

  return "Payment Made By";
};
  return (
    <div>
      <div className="card mb-0 mt-0 scroll-container ">
        <div
          className="d-flex p-2  justify-content-between align-items-center bg-light-theme  box-heade"
          style={{
            position: "sticky",
            top: "0",
            zIndex: "10",
            background: "#fff",
          }}
        >
          <h6 className="modal-title bg-light-theme-text">
            Payment & Booking History
          </h6>
          <div className="view-actions">
            <button
              type="button"
              onClick={handleClose}
              className="lni lni-close"
            ></button>
          </div>
        </div>

        <div className="card-body pt-3 pb-4">
          <div className=" d-flex justify-content-end mb-2">
            {isSelectedData?.bookingStatus === "ACCEPTED" &&
              isSelectedData?.balanceAmount > 0 && (
                <button
                  class="btn btn-sm btn-primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpen();
                  }}
                >
                  <i class="bx bx-plus me-1" />
                  Add Payment
                </button>
              )}
          </div>
          <h6
            className="fw-semibold "
            style={{
              marginBottom: "10px",
              // borderBottom: "1px solid #eee",
              paddingBottom: "6px",
            }}
          >
            Transaction
          </h6>
          {isLoadingBtn.listPayment ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <CircularProgress size={22} className="text-green" />
            </div>
          ) : isPayment?.length > 0 ? (
            isPayment.map((p, index) => {
              const styles = getStatusStyles(
                p?.paymentStatus || p?.refundStatus,
              );
              const isCompleted = p?.paymentCompleted;
              const isLast = index === isPayment.length - 1;
              const entryByText = p.entryBy || p.acceptedBy || "-";
              const hasRefundRequest = isPayment?.some(
  (item) =>
    item?.bookingTracking === "REFUND" &&
    item?.paymentHistoryId === p?.paymentHistoryId
);
              return (
                <div
                  key={index}
                  className="d-flex align-items-stretch"
                  style={{ gap: "12px" }}
                >
                  <div className="position-relative d-flex align-items-center flex-sm-column">
                    <div
                      className="w-24 h-24 rounded-circle d-flex align-items-center justify-content-center text-white"
                      style={{
                        backgroundColor: isLast ? styles.textColor : "#4caf50",
                        zIndex: 1,
                        flexShrink: 0,
                      }}
                    >
                      {!isLast ? (
                        <i className="bx bx-check text-white font-18"></i>
                      ) : p?.paymentStatus?.toUpperCase() === "PAID" ? (
                        <i className="bx bx-check text-white font-18"></i>
                      )  : p?.refundStatus?.toUpperCase() === "REFUNDED" ? (
                        <i className="bx bx-check text-white font-18"></i>
                      ) : p?.paymentStatus?.toUpperCase() === "STARTED" ? (
                        <i className="bx bx-time text-white font-18"></i>
                      ) : p?.paymentStatus?.toUpperCase() === "FAILED" ? (
                        <i className="bx bx-x text-white font-18"></i>
                      ) : <i className="bx bx-time text-white font-18"></i>}
                    </div>
                    {!isLast && (
                      <div className="position-absolute top-24 bottom-0  border-dotted-start border-success"></div>
                    )}
                  </div>
                  <div
                    style={{
                      flex: 1,
                      border: "1px solid #e0e0e0",
                      borderLeft: styles.borderLeft,
                      borderRadius: "6px",
                      backgroundColor: styles.background,
                      padding: "12px",
                      marginBottom: "12px",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <p
                        className="fw-bold"
                        style={{ color: styles.textColor }}
                      >
                        {p.paymentMode === "PAYMENTGATEWAY"
                          ? "Payment Gateway"
                          : p.refundMode === "PAYMENTGATEWAY"
                            ? "Payment Gateway"
                            : p.paymentMode === "MANUAL"
                              ? "Manual Payment"
                              : p.paymentMode === "FOCASHPAYMENT"
                                ? "FO Cash Payment"
                                : p.paymentMode === "BANKTRANSFER"
                                  ? "Bank Transfer"
                                  : p.paymentMode === "UPI"
                                    ? "UPI Payment"
                                    :p.bookingStatus==="REFUN"
                                    ?"Refund"
                                    : p.paymentMode === "CARD"
                                      ? "Card Payment"
                                      : p.paymentMode}
                      </p>
                      <h5
                        className=" fw-bold"
                        style={{ color: styles.textColor }}
                      >
                        ₹ {p.amount}
                      </h5>
                    </div>
                    <div className="row mt-0">
                      <div className="col-12 col-sm-12">
                        <div className="d-flex justify-content-between">
                          <p className="text-muted mb-1">
                            Pay status:{" "}
                            <span
                              className=" fw-bold"
                              style={{ color: styles.textColor }}
                            >
                             {getTransactionStatus(p)}
                            </span>
                          </p>
                          {isCompleted ? (
                            <i
                              className="bx bx-check-circle"
                              style={{
                                color: styles.textColor,
                                fontSize: "1.5rem",
                                verticalAlign: "middle",
                              }}
                              title="Payment Completed"
                            ></i>
                          ) : (
                            p?.paymentStatus === "STARTED" && (
                              <button
                                className="btn btn-sm text-white fw-bold py-0"
                                onClick={() =>
                                  handlePaymentCheck(
                                    p?.paymentHistoryId,
                                    p?.bookingId,
                                  )
                                }
                                disabled={payLoading}
                                style={{
                                  backgroundColor: styles.textColor,
                                  border: "none",
                                  padding: "4px 8px",
                                  fontSize: "0.8rem",
                                  borderRadius: "4px",
                                  minWidth: "100px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {payLoading ? (
                                  <CircularProgress
                                    size={18}
                                    className="text-white "
                                  />
                                ) : (
                                  "Check status"
                                )}
                              </button>
                            )
                          )}
                        </div>
                      </div>

                      <p className="small text-muted  mb-1">
                        By: <span className="fw-bold">{entryByText}</span>
                      </p>
                      <div className="col-12">
                        {p?.time && (
                          <p className="text-muted mb-0">
                            {
                              DateConverter.ISOToDisplayFormat(
                                DateConverter.convertToTimeZone(
                                  p?.time,
                                  uRLs.TIMEZONE,
                                ),
                              ).time
                            }{" "}
                            ,{"  "}
                            {
                              DateConverter.ISOToDisplayFormat(
                                DateConverter.convertToTimeZone(
                                  p?.time,
                                  uRLs.TIMEZONE,
                                ),
                              ).date
                            }
                          </p>
                        )}
                      </div>

                      <div className="col-col-12 mt-3 ">
                        {(p?.accountHolderName ||
                          p?.paymentMethod ||
                          p?.notes) && (
                          <div className="card mb-0 border">
                            <div className="card-body p-2">
                              <div className="col-12 mt-1">
                                <div className="d-flex justify-content-end align-items-center mb-2">
                                  {p?.transactionDateTime && (
                                    <p className="text-muted mb-0 fw-bold">
                                      {
                                        DateConverter.ISOToDisplayFormat(
                                          DateConverter.convertToTimeZone(
                                            p?.transactionDateTime,
                                            uRLs.TIMEZONE,
                                          ),
                                        ).time
                                      }
                                      {" , "}
                                      {
                                        DateConverter.ISOToDisplayFormat(
                                          DateConverter.convertToTimeZone(
                                            p?.transactionDateTime,
                                            uRLs.TIMEZONE,
                                          ),
                                        ).date
                                      }
                                    </p>
                                  )}
                                </div>
                                {p?.accountHolderName && (
                                  <p className="text-muted mb-1">
                                    Name:{" "}
                                    <span className="fw-bold">
                                      {capitalizeFirstLetter(
                                        p?.accountHolderName,
                                      )}
                                    </span>
                                  </p>
                                )}

                                {p?.paymentMethod && (
                                  <p className="text-muted mb-1">
                                    Payment Method:{" "}
                                    <span
                                      className={`fw-bold  ${getPaymentMethodClass(p.paymentMethod)}`}
                                    >
                                      {p.paymentMethod}
                                    </span>
                                  </p>
                                )}
                                {p?.transactionId && (
                                  <p className="text-muted mb-1">
                                    Transaction ID:{" "}
                                    <span className="fw-bold">
                                      {p.transactionId}
                                    </span>
                                  </p>
                                )}

                                {p?.notes && (
                                  <p className="text-muted mb-1">
                                    Notes:{" "}
                                    <span className="fw-bold">
                                      {capitalizeFirstLetter(p.notes)}
                                    </span>
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {/* Excess payment flag — set when this confirmed payment pushed
                        totalPaid past totalAmount (see backend's payment
                        reconciliation redesign) */}
                    {p?.excessAmount > 0 && (
                      <div
                        className="d-flex justify-content-between align-items-center p-2 rounded mt-2"
                        style={{ background: "#fff8e1", border: "1px solid #ffe082" }}
                      >
                        <span className="text-dark font-13">
                          <i className="bx bx-error-circle text-warning me-1" />
                          ₹{p.excessAmount} excess — {p.excessRefundedAt ? "refunded" : "refund needed"}
                        </span>
                        {!p.excessRefundedAt &&
                          (isLoadingBtn.refundExcess === p.paymentHistoryId ? (
                            <button className="btn btn-sm btn-warning" disabled>
                              <CircularProgress size={14} className="text-white" />
                            </button>
                          ) : (
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={() => handleRefundExcess(p.paymentHistoryId)}
                            >
                              Refund Excess
                            </button>
                          ))}
                      </div>
                    )}

                    {/* REFUND BUTTON */}

                    <div className="d-flex justify-content-end">
                      {isSelectedData?.bookingStatus === "CANCELLED" &&
                        p?.paymentMode === "PAYMENTGATEWAY" &&
                        p?.paymentStatus === "PAID" &&
                          !hasRefundRequest && (<>
                         {isLoadingBtn.initialteRefund === p.paymentHistoryId ? (
                                <button className="btn btn-danger btn-sm d-flex align-items-center" disabled>
                              <CircularProgress
                                size={16}
                                className=" text-white"
                              />
                              </button>
                            ) : (
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                              setRefundModal({
                                open: true,
                                paymentHistoryId: p.paymentHistoryId,
                                bookingId: p.bookingId,
                                amount: p.amount,
                              });

                              setRefundAmount(p.amount);
                            }}
                          >
                            Refund
                          </button>
                        )}
                        </>)}

                      {/* Manual/Cash Refund */}
                      {isSelectedData?.bookingStatus === "CANCELLED" &&
                        ["MANUAL", "FOCASHPAYMENT"].includes(p?.paymentMode) &&
                        p?.paymentStatus === "PAID" &&
                          !hasRefundRequest && (<>
                         {isLoadingBtn.initialteRefund === p._id ? (
                                <button className="btn btn-danger btn-sm d-flex align-items-center" disabled>
                              <CircularProgress
                                size={16}
                                className=" text-white"
                              />
                              </button>
                            ) : (
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                              setManualRefundModal({
                                open: true,
                                statusHistoryId: p._id,
                                bookingId: p.bookingId,
                                amount: p.amount,
                              });
                              setManualRefundRemarks("");
                            }}
                          >
                            Mark Refunded (Cash)
                          </button>
                        )}
                        </>)}

                      {/* Verify Refund */}
                      {p?.bookingTracking === "REFUND" &&
                       (p?.refundStatus === "STARTED" || p?.refundStatus === "PENDING")&& (
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() =>
                              setVerifyRefundModal({
                                open: true,
                                paymentHistoryId: p?.paymentHistoryId,
                                bookingId: p?.bookingId,
                                refundId: p?.refundId,
                                amount:p?.amount
                              })
                            }
                            disabled={isLoadingBtn.verifyRefund === p.refundId}
                          >
                             {isLoadingBtn.verifyRefund === p.refundId ? (
                              <CircularProgress
                                size={16}
                                className="text-white"
                              />
                            ) : (
                              "Verify Refund"
                            )}
                          </button>
                        )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-center p-3 text-muted">
              No payment transaction history found for this booking.
            </div>
          )}
        </div>
      </div>

      {cashLedger.length > 0 && (
        <div className="mt-3">
          <h6 className="fw-bold font-13 mb-2">Cash Management Ledger</h6>
          <div className="list-group">
            {cashLedger.map((entry) => (
              <div key={entry._id} className="list-group-item">
                <div className="d-flex justify-content-between">
                  <span className="fw-bold text-danger">₹ {entry.amount} refunded</span>
                  <span className="text-muted font-12">
                    {entry.transactionDateTime
                      ? DateConverter.ISOToDisplayFormat(
                          DateConverter.convertToTimeZone(entry.transactionDateTime, uRLs.TIMEZONE)
                        ).date
                      : ""}
                  </span>
                </div>
                <p className="text-muted mb-0 font-12">{entry.remarks}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {refundModal?.open && (
        <>
          <div className="modal-backdrop show"></div>
          <div className="modal show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <h6 className="modal-title  fw-semibold">Initiate Refund </h6>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={() =>
                      setRefundModal({
                        open: false,
                        paymentHistoryId: "",
                        bookingId: "",
                        amount: "",
                      })
                    }
                  ></button>
                </div>

                <div className="modal-content border-0 shadow-lg">
                  <div className="modal-body p-4">
                    <div className="text-center mb-3">
                      <div
                        className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light"
                        style={{ width: 55, height: 55 }}
                      >
                        <i
                          className="bx bx-undo text-danger"
                          style={{ fontSize: "28px" }}
                        />
                      </div>

                      <h5 className="mt-2 mb-1 fw-bold">Initiate Refund</h5>

                      <small className="text-muted">
                        Refund amount will be transferred to the customer's
                        account.
                      </small>
                    </div>

                    {/* Paid Amount Card */}
                    <div
                      className="border rounded-3 p-3 mb-3"
                      style={{
                        background: "#f8fff9",
                        borderColor: "#d8f3dc",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="text-muted">Paid Amount</span>

                        <span
                          className="fw-bold text-success"
                          style={{ fontSize: "1.2rem" }}
                        >
                          ₹ {refundModal.amount}
                        </span>
                      </div>
                    </div>

                    {/* Refund Amount */}
                    <div className="mb-3">
                      <label className="form-label fw-semibold mb-2">
                        Refund Amount
                      </label>

                      <div className="input-group">
                        <span className="input-group-text fw-bold">₹</span>

                        <input
                          type="number"
                          className="form-control"
                          value={refundAmount}
                          onChange={(e) => setRefundAmount(e.target.value)}
                          min={1}
                          max={refundModal.amount}
                          placeholder="Enter refund amount"
                        />
                      </div>
                    </div>

                    <div
                      className="d-flex align-items-start p-2 rounded"
                      style={{
                        background: "#fff8e1",
                        border: "1px solid #ffe082",
                      }}
                    >
                      <i className="bx bx-info-circle text-warning me-2 mt-1 font-18" />

                      <small className="text-dark">
                        Once initiated, the refund request will be sent for
                        processing and cannot be modified.
                      </small>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between modal-footer border-0">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() =>
                      setRefundModal({
                        open: false,
                        paymentHistoryId: "",
                        bookingId: "",
                        amount: "",
                      })
                    }
                  >
                    Cancel
                  </button>
                  {isLoadingBtn?.initialteRefund ? (
                    <button className="btn btn-danger" disabled>
                      <CircularProgress size={20} className="text-white" />
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-danger px-4"
                      onClick={() => {
                        handleInitiateRefund(
                          refundModal.paymentHistoryId,
                          refundModal.bookingId,
                          Number(refundAmount),
                        );

                        setRefundModal({
                          open: false,
                          paymentHistoryId: "",
                          bookingId: "",
                          amount: "",
                        });
                      }}
                    >
                      <i className="bx bx-money-withdraw me-1"></i>
                      Initiate Refund
                    </button>
                  )} 
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {manualRefundModal?.open && (
        <>
          <div className="modal-backdrop show"></div>
          <div className="modal show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <h6 className="modal-title  fw-semibold">Mark Refunded (Cash)</h6>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() =>
                      setManualRefundModal({ open: false, statusHistoryId: "", bookingId: "", amount: "" })
                    }
                  ></button>
                </div>
                <div className="modal-content border-0 shadow-lg">
                  <div className="modal-body p-4">
                    <div className="text-center mb-3">
                      <div
                        className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light"
                        style={{ width: 55, height: 55 }}
                      >
                        <i className="bx bx-money-withdraw text-danger" style={{ fontSize: "28px" }} />
                      </div>
                      <h5 className="mt-2 mb-1 fw-bold">Mark Cash Refund Complete</h5>
                      <small className="text-muted">
                        Use this once the amount has already been physically returned to the farmer.
                      </small>
                    </div>

                    <div
                      className="border rounded-3 p-3 mb-3"
                      style={{ background: "#f8fff9", borderColor: "#d8f3dc" }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="text-muted">Refund Amount</span>
                        <span className="fw-bold text-success" style={{ fontSize: "1.2rem" }}>
                          ₹ {manualRefundModal.amount}
                        </span>
                      </div>
                    </div>

                    <div className="mb-2">
                      <label className="form-label fw-semibold mb-2">Remarks</label>
                      <textarea
                        className="form-control"
                        rows={3}
                        placeholder="How was the refund made? (e.g. cash handed over on-site, receipt number, etc.)"
                        value={manualRefundRemarks}
                        onChange={(e) => setManualRefundRemarks(e.target.value)}
                      />
                    </div>

                    <div
                      className="d-flex align-items-start p-2 rounded"
                      style={{ background: "#fff8e1", border: "1px solid #ffe082" }}
                    >
                      <i className="bx bx-info-circle text-warning me-2 mt-1 font-18" />
                      <small className="text-dark">
                        This records a Cash Management Ledger entry and cannot be undone.
                      </small>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between modal-footer border-0">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() =>
                      setManualRefundModal({ open: false, statusHistoryId: "", bookingId: "", amount: "" })
                    }
                  >
                    Cancel
                  </button>
                  {isLoadingBtn?.initialteRefund ? (
                    <button className="btn btn-danger" disabled>
                      <CircularProgress size={20} className="text-white" />
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-danger px-4"
                      disabled={!manualRefundRemarks.trim()}
                      onClick={() => {
                        handleInitiateManualRefund(
                          manualRefundModal.statusHistoryId,
                          manualRefundModal.bookingId,
                          Number(manualRefundModal.amount),
                          manualRefundRemarks.trim()
                        );
                        setManualRefundModal({ open: false, statusHistoryId: "", bookingId: "", amount: "" });
                      }}
                    >
                      <i className="bx bx-check me-1"></i>
                      Mark Refunded
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {verifyRefundModal?.open && (
        <>
          <div className="modal-backdrop show"></div>
          <div className="modal show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <h6 className="modal-title  fw-semibold"> Verify Refund</h6>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={() =>
                      setVerifyRefundModal({
                        open: false,
                        paymentHistoryId: "",
                        bookingId: "",
                        refundId: "",
                      })
                    }
                  ></button>
                </div>

                <div className="modal-body p-0">
                 <div className="text-center mb-0">
                <div
                  className="p-3  border"
                  style={{ backgroundColor: "#f8f9fa" }}
                >
                  <i
                    className="ri-refund-2-line text-warning"
                    style={{ fontSize: "3rem" }}
                  ></i>

                    <p className="text-muted mb-3">
                    Are you sure you want to verify this refund amount?
                  </p>

                  <div
                    className="d-inline-flex align-items-center px-4 py-2 rounded-pill"
                    style={{
                      backgroundColor: "#fff3cd",
                      border: "1px solid #837548",
                    }}
                  >
                    <span className="fw-semibold me-2">Refund Amount:</span>
                    <span className="fw-bold text-success fs-5">
                      ₹{verifyRefundModal?.amount || 0}
                    </span>
                  </div>
                </div>
              </div>
                
                  
                </div>

                <div className="d-flex justify-content-between modal-footer border-0">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() =>
                      setVerifyRefundModal({
                        open: false,
                        paymentHistoryId: "",
                        bookingId: "",
                        refundId: "",
                      })
                    }
                  >
                    Cancel
                  </button>
                  {isLoadingBtn.verifyRefund ? (
                    <button className="btn btn-danger" disabled>
                      <CircularProgress size={20} className="text-white" />
                    </button>
                  ) : (
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        handleVerifyRefund(
                          verifyRefundModal.paymentHistoryId,
                          verifyRefundModal.bookingId,
                          verifyRefundModal.refundId,
                        );

                        setVerifyRefundModal({
                          open: false,
                          paymentHistoryId: "",
                          bookingId: "",
                          refundId: "",
                        });
                      }}
                    >
                      Yes, Verify
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default PaymentHistory;
